(window.gridSlider = function ($, Behaviors) {

  "use strict";
  
  function gridSlider(elem) {
    Behaviors.init(gridSlider, this, arguments);

    let gridItems = document.querySelectorAll('.grid-item');

    if (gridItems.length > 0) {
      gridItems.forEach(item => {
        item.querySelectorAll('.js-slider-control div').forEach(item => {
          item.addEventListener('click', function(e){
            console.log('ss click');
            e.stopPropagation();
            e.preventDefault();
  
            this.closest('.grid-item').classList.toggle('grid-item--active');
          });
        });

        item.querySelectorAll('.js-variant[data-sold="true"]').forEach(item => {
          let soldIndex = item.dataset.index;
          item.closest('.grid-item').querySelector(`.js-grid-qa[data-index="${soldIndex}"]`).classList.add('grid-item__size-item--sold');
        });

        item.querySelectorAll('.js-grid-qa').forEach(item => {
          item.addEventListener('click', function(e){
            e.stopPropagation();
            e.preventDefault();
            let formData;
            let index = this.dataset.index;
            let variantID = this.closest('.grid-item').querySelector(`.js-variant[data-index="${index}"]`).textContent;
            let eta = '';
            let finalSale = '';
            formData = {
              'items': [{
                'id': variantID,
                'quantity': 1
              }]
             };
            if (this.closest('.grid-item').querySelector(`.js-variant[data-index="${index}"]`).dataset.eta != '') {
              eta = this.closest('.grid-item').querySelector(`.js-variant[data-index="${index}"]`).dataset.eta;
              formData = {
                'items': [{
                  'id': variantID,
                  'quantity': 1,
                  'properties': {
                    '_eta': eta
                  }
                }]
               };
            };
            if (this.closest('.grid-item').querySelector('.final-sale')) {
              finalSale = 'Final Sale';
              formData = {
                'items': [{
                  'id': variantID,
                  'quantity': 1,
                  'properties': {
                    '_finalsale': finalSale            
                  }
                }]
               };
            }
            if(finalSale !== "" && eta !== ""){
              formData = {
                'items': [{
                  'id': variantID,
                  'quantity': 1,
                  'properties': {
                    '_finalsale': finalSale,
                    '_eta': eta
                  }
                }]
               };
            }
         
             console.log(formData)
             fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
             })
             .then(response => {
                if(response.ok) {
                  document.querySelector('.js-cart').click();
                }
             })
             .catch((error) => {
                console.error('Error:', error);
             });
          });
        });
      });
    }
  }

  Behaviors.inherit(gridSlider, Behaviors.Behavior);
  gridSlider.QUERY = 'body';

  Behaviors.register_behavior(gridSlider);
  
  return gridSlider;

  }(window.jQuery, window.Behaviors));